import { pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver'
import { ReactNode } from 'react';
import FinancialAgreementDoc from './financial-agreement-doc';
import useFinancialAgreementData from '@nkr/store/match/hooks/use-financial-agreement-data';

type TProps = {
    donorId: number,
    recipientId: number,
    centerId: number,
    className?: string,
    children?: ReactNode
}

const FinancialAgreement = ({ centerId, donorId, recipientId, className, children }: TProps) => {
    const { list } = useFinancialAgreementData(centerId, donorId, recipientId);
    const fileName = `financial-info-${centerId}-${donorId}-${recipientId}.pdf`;

    const downloadPdf = async () => {
        const blob = await pdf(<FinancialAgreementDoc agreements={list} />).toBlob();
        saveAs(blob, fileName); // Use file-saver to trigger download
    };

    return (
        <div className={className} onClick={downloadPdf} style={{ cursor: 'pointer' }}>
            {children}
        </div>
    );
};

export { FinancialAgreement };
